import React, { Fragment } from 'react';
import { Router } from 'react-router-dom';
import { ThemeProvider, Theme, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from 'services/AuthProvider';
import history from './helpers/navigation';
import Notifier from './components/_common/Notifier';
import { GlobalStyle } from './globalStyle';

import store from './store/store';
import './services/i18n';

import { App } from './App';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
const theme = createTheme({
  palette: {
    primary: { main: '#2EA1F8' },
  },
  typography: {
    fontFamily: 'Rubik, Helvetica, sans-serif',
  },
  spacing: 8,
});

export const AppContainer = () => {
  return (
    <Fragment>
      <GlobalStyle />
      <Provider store={store}>
        <ErrorBoundary>
          <Router history={history}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <AuthProvider>
                  <CssBaseline />

                  <SnackbarProvider
                    maxSnack={4}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    autoHideDuration={10000}>
                    <Notifier />
                  </SnackbarProvider>

                  <App />
                </AuthProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </Router>
        </ErrorBoundary>
      </Provider>
    </Fragment>
  );
};
